import {useEffect, useState} from 'react';
import {accountApiPath, platform} from './transport';

/** Authenticated media is a temporary view of bytes owned by the server. */
export function useMediaAddress(address: string): {source: string | null; error: unknown | null} {
  const protectedPath = platform().kind === 'desktop' ? accountApiPath(address) : null;
  const [loaded, setLoaded] = useState<{address: string; source: string | null; error: unknown | null} | null>(null);
  const [accountVersion, setAccountVersion] = useState(0);
  useEffect(() => {
    if (!protectedPath) return;
    const controller = new AbortController();
    let objectUrl: string | null = null;
    const clear = () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = null;
    };
    const accountChanged = () => {clear(); setLoaded(null); setAccountVersion(value => value + 1);};
    window.addEventListener('eightbots-account-changed', accountChanged);
    void platform().fetch(protectedPath, {signal: controller.signal}).then(async response => {
      if (!response.ok) throw new Error(`Image request failed: HTTP ${response.status} ${await response.text()}`);
      const blob = await response.blob();
      if (!blob.type.startsWith('image/')) throw new Error('The image response did not contain an image.');
      if (controller.signal.aborted) return;
      objectUrl = URL.createObjectURL(blob);
      setLoaded({address, source: objectUrl, error: null});
    }).catch(error => {if (!controller.signal.aborted) setLoaded({address, source: null, error});});
    return () => {clear(); window.removeEventListener('eightbots-account-changed', accountChanged);};
  }, [address, protectedPath, accountVersion]);
  return protectedPath ? loaded?.address === address ? loaded : {source: null, error: null} : {source: address, error: null};
}
